import { render, staticRenderFns } from "./zlCertification.vue?vue&type=template&id=5378cbaa&scoped=true&"
import script from "./zlCertification.vue?vue&type=script&lang=js&"
export * from "./zlCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5378cbaa",
  null
  
)

export default component.exports